import QuoteView from './QuoteView'

export * from './QuoteView'
export default QuoteView
